import { wrap as withStyle } from 'utils/styles'

export default withStyle(
  (props) => `
    border-radius: 3px;
    background-color: ${props.theme.alertInfoBgColor};
    color: #fff;
    padding: 8px;
    margin: 2px;

    && p {
      color: #fff;
    } 

    > .anticon-close {
      float: right;
      :hover {
        opacity: .6;
      }
    }

    &:after {
      visibility: hidden;
      display: block;
      font-size: 0;
      content: " ";
      clear: both;
      height: 0;
    }
  `
)
